<template>
   <div class="container P-5 mt-5 mb-5">
   
        <h1 class="text-center">การส่งออกทุเรียน</h1>
        <p>
            ปัจจุบันผลไม้ของไทยที่จีนอนุญาตให้นำเข้าได้มี 23 ชนิด คือ ทุเรียน ลำไย มังคุด สับปะรด ละมุดกล้วย เสาวรส ลิ้นจี่ มะพร้าว น้อยหน่า มะขาม มะละกอ มะเฟือง มะม่วง ฝรั่ง เงาะ ชมพู่ ขนุน สละ ลองกอง ส้มเขียวหวาน ส้ม และส้มโอ
        </p>
        <p>
            ผลไม้ 5 ชนิดที่ต้องปฏิบัติตามพิธีสารไทย-จีน ได้แก่ ลำไย ลิ้นจี่ ทุเรียน มังคุดและมะม่วงต้องขึ้นทะเบียนสวน GAP และทะเบียนโรงคัดบรรจุ GMP กับกรมวิชาการเกษตร สำหรับลำไยและทุเรียน ต้องจดทะเบียนเป็นผู้ส่งออกกับกรมวิชาการเกษตร โดยภาชนะหรือกล่องบรรจุ ต้องระบุข้อความที่กำหนดดังนี้:
        </p>
        <ul>
            <li>ชื่อบริษัทผู้ส่งออก (Name of exporting company)</li>
            <li>ชนิดผลไม้ (Fruit Type)</li>
            <li>หมายเลขโรงหีบห่อจดทะเบียน (ทะเบียนโรงคัดบรรจุ)</li>
            <li>วันที่บรรจุ (Packing date)</li>
            <li>ระบุข้อความเป็นภาษาอังกฤษ หรือภาษาจีน ว่า Export to the People’s Republic of China</li>
        </ul>
        <p>
            และต้องปราศจากแมลงวันผลไม้ ไม่มีกิ่ง ก้าน ใบและดิน และต้องไม่พบสาร Methamidophos ในผลไม้ที่ส่งออก ส่วนลำไยที่ส่งออกมีข้อกำหนดในการใช้สารซัลเฟอร์ไดออกไซด์ (SO2) ต้องไม่เกิน 50 PPM. ที่เนื้อลำไย ลิ้นจี่ต้องมีก้านยาวไม่เกิน 15 ซม. ภาชนะบรรจุต้องใหม่ สะอาด และระบุข้อความตามที่กำหนด
        </p>
        <p>
            ผลไม้ไทยที่ส่งออกไปจีน ไม่ต้องเสียภาษีนำเข้า โดยต้องมีหนังสือรับรองถิ่นกำเนิดสินค้า (Form E) ไปแสดงต่อศุลกากรประเทศจีน สามารถขอ Form E ได้ที่สำนักบริการการค้าต่างประเทศ กรมการค้าต่างระเทศ อย่างไรก็ตาม จีนเก็บภาษีมูลค่าเพิ่มร้อยละ 13 และหากส่งผ่านมณฑลใดจะต้องศึกษากฎระเบียบของมณฑลนั้นด้วย
        </p>
            <p>
                <a href="https://www.dft.go.th/%E0%B9%81%E0%B8%AA%E0%B8%94%E0%B8%87%E0%B9%80%E0%B8%99%E0%B8%B7%E0%B9%89%E0%B8%AD%E0%B8%AB%E0%B8%B2/ArticleId/7313" target="_blank">กรมการค้าต่างประเทศ กระทรวงพาณิชย์</a>
            </p>
   
    

            ทุเรียนสด |  50396 
            <div class="table-responsive">
        <table class="table table-bordered">
            <thead class="thead-dark">
                <tr>
                    <th>พิกัดศุลกากรและรหัสสถิติ</th>
                    <th>ประกาศฯ/ระเบียบฯ</th>
                    <th>เหตุผล</th>
                    <th>หน่วยงานที่รับผิดชอบ</th>
                    <th>ผู้มีอำนาจอนุญาต</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>ตามชนิดประเภทสินค้า</td>
                    <td>
                        - ประกาศกระทรวงพาณิชย์ว่าด้วยการส่งสินค้าออกไปนอกราชอาณาจักร (ฉบับที่ 91) พ.ศ. 2542 ลงวันที่ 9 กรกฎาคม 2542<br>
                        - ประกาศกรมวิชาการเกษตร เรื่อง หลักเกณฑ์ วิธีการและเงื่อนไขการจดทะเบียนเป็นส่งออกผลทุเรียนสด พ.ศ. 2563
                    </td>
                    <td>เพื่อให้การส่งผลทุเรียนสดออกไปต่างประเทศเป็นไปด้วยความเรียบร้อยและเป็นผลดีต่อเศรษฐกิจของประเทศโดยส่วนรวม</td>
                    <td>
                        - กรมการค้าต่างประเทศ (กองบริหารการค้าสินค้าทั่วไป)<br>
                        - กรมวิชาการเกษตร กระทรวงเกษตรและสหกรณ์
                    </td>
                    <td>กรมศุลกากรตรวจปล่อยสินค้าตามบัญชีรายชื่อผู้ส่งออกที่กรมวิชาการเกษตรแจ้งให้กรมศุลกากรทราบ</td>
                </tr>
            </tbody>
        </table>



        <h2>ขอบเขตการควบคุม</h2>
        <p>ผลทุเรียนสด</p>
        <h3>ระเบียบและหลักเกณฑ์</h3>
        <ol>
            <li>
                ผู้ส่งทุเรียนสดออกไปนอกราชอาณาจักรจะต้องเป็นผู้ที่ได้จดทะเบียนเป็นผู้ส่งทุเรียนสดออกไปนอกราชอาณาจักรไว้ต่อกรมวิชาการเกษตร กระทรวงเกษตรและสหกรณ์ ตามหลักเกณฑ์ เงื่อนไข และวิธีการที่กรมวิชาการเกษตรกำหนด และกรมวิชาการเกษตรแจ้งบัญชีรายชื่อและหมายเลขทะเบียนผู้ส่งออกทุเรียนสดให้กรมศุลกากรทราบเพื่อประกอบการส่งออก
            </li>
            <li>
                ผู้ส่งออกจะต้องติดป้าย หรือฉลาก หรือประทับข้อความ โดยระบุข้อความต่อไปนี้เป็นภาษาอังกฤษให้ชัดเจนที่ภาชนะบรรจุ
                <ol type="1">
                    <li>ชื่อและหมายเลขทะเบียนผู้ส่งออก</li>
                    <li>ชื่อพืชและพันธุ์</li>
                    <li>ชั้นและน้ำหนักของสินค้า</li>
                    <li>ประเทศผู้ผลิต</li>
                    <li>กำหนดเวลาอายุการรับประทาน</li>
                </ol>
            </li>
            <li>
                ผู้ส่งออกรายงานการส่งทุเรียนสดออกไปนอกราชอาณาจักรต่อกรมวิชาการเกษตร ตามหลักเกณฑ์ที่กรมวิชาการเกษตรกำหนด
            </li>
            <li>
                มิให้ใช้บังคับแก่กรณีนำติดตัวออกไปเพื่อใช้เฉพาะตัว หรือการส่งออกโดยมิใช่การค้า หรือเพื่อเป็นตัวอย่างในปริมาณที่สมควร
            </li>
        </ol>

        <h3>ระเบียบและหลักเกณฑ์</h3>


        <div class="container mb-3">
    <img src="@/assets/durain/durian-image1.png" class="img-fluid" alt="">
</div>


        <h2 class="text-center">ขั้นตอนการส่งออกทุเรียนสด</h2>
        <table class="table table-bordered table-responsive">
            <thead class="thead-light">
                <tr>
                    <th>ลำดับ</th>
                    <th>ขั้นตอน</th>
                    <th>รายละเอียด</th>
                    <th>หน่วยงานผู้รับผิดชอบ</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>จดทะเบียนนิติบุคคล</td>
                    <td>ผู้ประกอบการจะได้รับการยกเว้นและสิทธิต่าง ๆ ในการขอคืนภาษีซึ่งผู้ประกอบการจะต้องมีสถานะเป็นนิติบุคคลเท่านั้น</td>
                    <td>กรมพัฒนาธุรกิจการค้า</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>จดทะเบียนภาษีมูลค่าเพิ่ม</td>
                    <td></td>
                    <td>กรมสรรพากร</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>ทำบัตรประจำตัวผู้ส่งออก-นำเข้าสินค้า</td>
                    <td>
                        <p>
            ในการติดต่อกรมการค้าต่างประเทศ เพื่อขอใบอนุญาตและหนังสือรับรองการส่งออก-นำเข้าสินค้า ผู้ประกอบการส่งออก-นำเข้า จะต้องปฏิบัติตามระเบียบ ประกาศที่กรมการค้าต่างประเทศและหน่วยงานอื่นๆ ที่เกี่ยวข้องกำหนดไว้ให้ครบถ้วน เพื่อเป็นการอำนวยความสะดวก ลดจำนวนเอกสาร และลดขั้นตอน ในการติดต่อราชการ กรมการค้าต่างประเทศจึงกำหนดหลักเกณฑ์และวิธีการให้ผู้ประกอบการลงทะเบียนผู้ประกอบการ (Registration Database) เพื่อขอใช้งาน User Name กลางนี้ร่วมกับบริการ และ/หรือระบบงานต่างๆ ของกรมการค้าต่างประเทศ โดยมีคำแนะนำในการเตรียมเอกสารและปฏิบัติตามขั้นตอน ดังนี้
        </p>
        <ol>
            <li>ผู้ประกอบการส่งออก-นำเข้า และผู้รับมอบอำนาจ ต้องลงทะเบียนผู้ประกอบการทางระบบอิเล็กทรอนิกส์ เว็บไซต์กรมการค้าต่างประเทศ <a href="http://reg-users.dft.go.th">reg-users.dft.go.th</a> ส่งข้อมูลไปยังระบบฯ ของกรมการค้าต่างประเทศ</li>
            <li>ผู้ประกอบการส่งออก-นำเข้า/ผู้รับมอบอำนาจ กรอกข้อมูลคำร้องขอมีบัตรประจำตัวผู้ส่งออก-นำเข้า (แบบ บก.1) และ/หรือบัตรประจำตัวผู้รับมอบอำนาจ (แบบ บก.1/1) ในระบบคอมพิวเตอร์ของเว็บไซต์กรมการค้าต่างประเทศ (reg-users.dft.go.th) จากนั้นบันทึกส่งข้อมูลไปยังระบบฯ กรมการค้าต่างประเทศ</li>
            <li>ผู้ประกอบการส่งออก-นำเข้า และ/หรือผู้รับมอบอำนาจต้องยื่นคำร้องขอมีบัตรประจำตัวฯ ด้วยตนเอง ลงลายมือชื่อและ/หรือตราประทับของบริษัท/ห้าง/ร้าน ในคำร้องขอมีบัตรประจำตัวฯ ต่อหน้าเจ้าหน้าที่งานทะเบียน พร้อมแสดงเอกสารประกอบคำขอที่กรมการค้าต่างประเทศกำหนด</li>
            <li>กรณีผู้ประกอบการส่งออก-นำเข้ามอบอำนาจให้บุคคลอื่นยื่นคำร้องขอมีบัตรประจำตัว ผู้ส่งออก-นำเข้าและ/หรือบัตรประจำตัวผู้รับมอบอำนาจ ให้ทำหนังสือมอบอำนาจให้ยื่นคำร้องขอมีบัตรประจำตัวฯ (แบบ บก.2) และหนังสือรับรองลายมือชื่อผู้มอบอำนาจ (แบบ บก.3) รับรองโดยทนายความ ที่เป็นสมาชิกสภาทนายความ/สมาชิกสามัญ/วิสามัญแห่งเนติบัณฑิตยสภา ผ่านทางระบบคอมพิวเตอร์ของเว็บไซต์กรมการค้าต่างประเทศ (reg-users.dft.go.th)</li>
        </ol>
        <p>ใช้สำหรับยื่นฟอร์ม ACFTA (ข้อตกลงการค้าเสรีอาเซียน-จีน)</p>
                    </td>
                    <td>กรมการค้าต่างประเทศ</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>จดทะเบียนเป็นผู้ส่งออกสินค้าเกษตรไปนอกราชอาณาจักร</td>
                    <td>   
        <ul>
            <li>
                ส่งออกทุเรียนสดออกไปนอกราชอาณาจักร ปฏิบัติตามประกาศกรมวิชาการเกษตร เรื่อง หลักเกณฑ์ วิธีการและเงื่อนไขการจดทะเบียนเป็นผู้ส่งผลทุเรียนสดออกไปนอกราชอาณาจักร 
                (ตามประกาศกรมวิชาการเกษตร เรื่อง หลักเกณฑ์ วิธีการและเงื่อนไขการจดทะเบียนเป็นผู้ส่งผลทุเรียนสดออกไปนอกราชอาณาจักร 
                พ.ศ. 2556 ลงวันที่ 5 มิถุนายน 2556)
            </li>
            <li>
                หนังสือสำคัญแสดงการจดทะเบียนเป็นผู้ส่งผลทุเรียนสดออกไปนอกราชอาณาจักร มีอายุ 2 ปี นับแต่วันออกหนังสือสำคัญการจดทะเบียน
                <br>
                ตัวอย่างหมายเลขทะเบียน: <strong>DU-1-XX-XXX</strong>
            </li>
        </ul></td>
                    <td>กรมวิชาการเกษตร</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>ขอใบรับรองปลอดศัตรูพืช (Phytosanitary certificate : PC)</td>
                    <td>ขั้นตอนตามเอกสาร “การออกใบรับรองสุขอนามัยสำหรับพืชควบคุมเฉพาะ”</td>
                    <td>กรมวิชาการเกษตร</td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>ขอหนังสือรับรองถิ่นกําเนิดสินค้า</td>
                    <td> <ol>
            <li>
                <strong>หนังสือรับรองถิ่นกำเนิดสินค้าทั่วไป</strong> 
                คือเอกสารที่นำไปใช้รับรองถิ่นกำเนิดสินค้า แต่ไม่สามารถนำไปขอยกเว้นหรือลดหย่อนภาษีอากรขาเข้าได้ เรียกว่า Ordinary Certificate of Origin
            </li>
            <li>
                <strong>หนังสือรับรองถิ่นกำเนิดสินค้าแบบพิเศษ</strong> 
                ที่นำไปใช้เพื่อขอรับสิทธิพิเศษทางภาษีศุลกากร (ขอยกเว้น หรือลดหย่อนภาษีอากรขาเข้า) เรียกว่า Preferential Certificate of Origin
            </li>
        </ol>
        <p>แล้วใบ C/O 2 ประเภทนี้แตกต่างกันอย่างไร?</p>
        <ul>
            <li>
                <strong>Ordinary Certificate of Origin</strong>: ขอเรียกสั้นๆว่าแบบทั่วไป แบบทั่วไปนี้คือเอกสารที่ใช้เพื่อยืนยันกับผู้ซื้อว่า สินค้าที่ส่งออกไปนั้นประกอบด้วยวัตถุดิบภายในประเทศ มีการผลิต หรือผ่านขั้นตอนกระบวนการผลิตภายในประเทศ
            </li>
            <li>
                <strong>Preferential Certificate of Origin</strong>: ศัพท์นำเข้าส่งออกเราเรียกเอกสารสิ่งนี้ว่า "ฟอร์ม" ตัวอย่างเช่น FORM E (ฟอร์มอี) ซึ่งเป็น C/O ที่รับรองว่าสินค้าถูกผลิตในประเทศจีน และ FORM E นี้ ที่ใช้มาขอยกเว้น/ลดหย่อนภาษีอากรขาเข้าจากกรมศุลกากร C/O ที่ใช้ยกเว้นหรือลดหย่อนภาษีได้จึงเป็นชนิดพิเศษ
            </li>
        </ul>
        <p>หนังสือรับรองถิ่นกำเนิดสินค้า การใช้สิทธิพิเศษทางการค้าภายใต้เขตการค้าเสรีต่างๆ เป็นหนังสือรับรองฯ ที่ออกให้แก่ผู้ส่งออกเพื่อใช้ในการขอรับสิทธิพิเศษตามความตกลงว่าด้วยเขตการค้าเสรีต่างๆ ได้แก่:</p>
        <ul>
            <li>ความตกลงว่าด้วยเขตการค้าเสรีอาเซียน-จีน ใช้ Form E</li>
        </ul></td>
                    <td>กรมการค้าต่างประเทศ</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>บริการค้นหาข้อมูลอัตราภาษีและศูนย์บริการข้อมูล FTA Center</td>
                    <td></td>
                    <td>กรมเจรจาการค้าระหว่างประเทศ</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>บริการช่วยเหลือและสนับสนุนการทำธุรกิจส่งออกสินค้า</td>
                    <td></td>
                    <td>กรมส่งเสริมการค้าระหว่างประเทศ</td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>ตรวจสอบชดเชยค่าภาษีอากรสินค้าส่งออกที่ผลิตในราชอาณาจักร</td>
                    <td></td>
                    <td>กรมศุลกากร</td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>ขั้นตอนการผ่านพิธีการศุลกากรขาออก</td>
                    <td>เมื่อสินค้าได้รับการรับรองการส่งออก และได้รับใบอนุญาตต่างๆเพื่อใช้ในการนำเข้าแล้วผู้ส่งออกต้องเตรียมเอกสารสำคัญต่างๆเช่นใบขนสินค้าขาออก Commercial Invoice และ Packing listเป็นต้น เพื่อใช้ในขั้นตอนการผ่านพิธีการศุลกากรในประเทศไทยและในประเทศนำเข้าด้วย</td>
                    <td>กรมศุลกากร</td>
                </tr>
            </tbody>
        </table>
        <div class="alert alert-warning" role="alert">

            หมายเหตุ: เนื่องจากทุเรียนเป็นผลไม้ที่ 3 สามารถคงความสดอยู่ได้ไม่เกิน 20 วันและคลายความร้อนสูงในการขนส่งทุเรียนจะถูกจัดเก็บในตู้สินค้าห้องเย็นที่มีอุณหภูมิ 13 ถึง 15 องศาเซลเซียส และมีการเปิดช่องระบายอากาศเพื่อระบายความร้อน ดังนั้นผู้ส่งออกจำเป็นต้องเลือกรูปแบบในการขนส่งทุเรียนที่เหมาะสมเพื่อให้คงความสดใหม่ของผลไม้โดยคำนึงถึงเรื่องระยะเวลาในการขนส่งเป็นสำคัญ
        </div>

        

        <div class="container mb-3">
            
    <img src="@/assets/durain/durian-image3.jpg" class="img-fluid" alt="">
    <img src="@/assets/durain/durian-image2.jpg" class="img-fluid" alt="">
    
    <img src="@/assets/durain/durian-image5.jpg" class="img-fluid" alt="">
    <img src="@/assets/durain/durian-image4.jpg" class="img-fluid" alt="">
    <img src="@/assets/durain/durian-image0.png" class="img-fluid" alt="">
   



</div>


    </div></div>
  </template>
  
  <script>
  export default {
    name: 'DurianPage' // เปลี่ยนชื่อเป็นหลายคำ
  }
  </script>
  